export default "__VITE_ASSET__BEX40fAO__"